import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from './ui/dropdown-menu';
import { LanguageFlag } from './Flag';
import { Check, ChevronDown, Globe } from 'lucide-react';

export const LanguageSwitcher = ({ variant = 'nav' }) => {
  const { language, setLanguage, languages, languageNames, languageFlags } = useLanguage();

  const triggerClass = variant === 'sidebar'
    ? 'w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#A1A1AA] hover:bg-white/5 hover:text-white transition-colors'
    : 'flex items-center gap-2 px-2 sm:px-3 py-2 rounded-full text-white/90 hover:text-[#32CD32] border border-white/15 hover:border-[#32CD32]/50 transition-colors';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={triggerClass} data-testid={`language-switcher-${variant}`}>
          {variant === 'sidebar' ? (
            <>
              <Globe className="w-5 h-5 flex-shrink-0" />
              <span className="text-sm flex-1 text-left">{languageNames[language]}</span>
              <LanguageFlag language={language} emoji={languageFlags[language]} size={20} />
            </>
          ) : (
            <>
              <LanguageFlag language={language} emoji={languageFlags[language]} size={22} />
              <span className="hidden sm:inline text-xs font-medium uppercase tracking-wider">
                {languageNames[language]}
              </span>
              <ChevronDown className="w-3 h-3 opacity-70" />
            </>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#121212] border-white/15 text-white min-w-[200px]"
      >
        {languages.map((code) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code)}
            className="cursor-pointer gap-3 focus:bg-white/10 focus:text-[#32CD32]"
            data-testid={`language-option-${code}`}
          >
            <LanguageFlag language={code} emoji={languageFlags[code]} size={22} />
            <span className="flex-1">{languageNames[code]}</span>
            {language === code && <Check className="w-4 h-4 text-[#32CD32]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
